module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noDriver":"No driver"},"de":{"noDriver":"Kein Fahrer"},"fr":{"noDriver":"Pas de conducteur"},"it":{"noDriver":"Nessun conducente"}}')
  delete Component.options._Ctor
}
